import React, { Component } from 'react'

import {
    Grid,
    GridCell,
} from "@bdfx/mergado-ui-kit"

import ShapeType from "shape-entities/types/shape";

import {
    FormNameType,
} from "app/types/model-types";

import trans from "trans";
import { StyledToggler } from './common-shape-form';
import { intboolean } from 'app/types/app-types';
import { imageFromElementsGetImageBlob } from 'app/helpers/api';
import { AxiosResponse } from 'axios';
import { RandomProduct } from 'shape-edit/types';
import ImageFromElementsShape from 'shape-entities/types/ImageFromElementsShape';

interface Props {
    formName: FormNameType
    randomProduct: RandomProduct
    shape: ShapeType
    change: Function
}

class ImageFromElementForm extends Component<Props> {
    constructor(props) {
        super(props)

        this.state = {
            allCustomSetFiles: null,
            isLoading: false,
        }
    }

    getContentFromProps = (props: Props) : string|null => {
        const { shape } = this.props
        const content =  shape.image_xml_element && props.randomProduct.serialized_data && typeof props.randomProduct.serialized_data[shape.image_xml_element] !== 'undefined' ? props.randomProduct.serialized_data[shape.image_xml_element] : null

        return Array.isArray(content) && typeof content[0] === 'string' ? content[0] : (typeof content === 'string' ? content : null)
    }

    handleIsRemoveBackground = (newValue: intboolean) => {
        const { shape, formName, randomProduct } = this.props
        const content = this.getContentFromProps(this.props)

        console.debug(`handle remove background, the element is ${shape.image_xml_element} the content is ${content}`)
        imageFromElementsGetImageBlob(randomProduct?.id, content, newValue, shape.index)
            .then((response: AxiosResponse<string>) => {
                const imageBlob = response.data

                this.props.change(formName, `shapes.${shape.index}`, {
                    ...shape,
                    imageBlob: imageBlob,
                    is_remove_background: newValue,
                })
            })
            .catch((error) => {
                console.error('imageFromElementsGetImageBlob error', error)
            })
    }

    render() {
        const { shape, formName } = this.props

        return (
            <Grid cols={'auto max-content'} gap={'20px'}>
                <GridCell
                    onClick={() => this.handleIsRemoveBackground(shape.is_remove_background ? 0 : 1)}
                    style={{ alignSelf: 'center', cursor: 'pointer' }}>
                    {trans('remove_background')}
                </GridCell>
                <GridCell style={{ alignSelf: 'center' }}>
                    <StyledToggler
                        value={shape.is_remove_background}
                        onChange={(newValue) => this.handleIsRemoveBackground(newValue)}
                    />
                </GridCell>
            </Grid>
        )
    }
}

export default ImageFromElementForm